// extracted by mini-css-extract-plugin
module.exports = {"block":"loader_block__2frd2","header":"loader_header__24dXM","first":"loader_first__38aXk","second":"loader_second__2SuwV","bar":"loader_bar__3Zu_D"};